import { Icon } from '@dc-shared-web/components/base/Icon'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import React, { PropsWithChildren, ReactNode } from 'react'

export type EmptyStateProps = PropsWithChildren<{
  /** Icon to display */
  icon: IconDefinition
  /** Title for the empty state fallback */
  title: string
  /** Description for the empty state fallback. */
  description: string | ReactNode
  /** Action slot to display */
  actionSlot?: React.ReactNode
}>

export const EmptyState = ({
  icon,
  title,
  description,
  actionSlot,
}: EmptyStateProps) => (
  <EmptyStateContainer>
    <Icon icon={icon} />
    <EmptyStateTitle>{title}</EmptyStateTitle>
    <EmptyStateDescription>{description}</EmptyStateDescription>
    {actionSlot ? actionSlot : null}
  </EmptyStateContainer>
)

function EmptyStateContainer({ children }: { children: React.ReactNode }) {
  return (
    <div
      className='tw-flex tw-flex-col tw-justify-center tw-h-full tw-grow tw-gap-4 tw-items-center [&>svg]:tw-w-12 [&>svg]:tw-h-12'
      role='alert'
      aria-live='polite'
    >
      {children}
    </div>
  )
}

function EmptyStateTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3 className='tw-text-gray-500 tw-text-base tw-font-medium'>{children}</h3>
  )
}

function EmptyStateDescription({ children }: { children: React.ReactNode }) {
  return (
    <p className='!tw-text-gray-500 tw-font-normal tw-text-sm tw-text-center tw-text-balance tw-max-w-[50vw]'>
      {children}
    </p>
  )
}
